/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import { BaseApiModel } from './BaseApiModel';

export class ModalityVehicle extends BaseApiModel {
  public code: string;
  public description: string;
  public regiondId: number;
  public createdAt: string;
  public modifiedAt: string;
}
